// src/Dashboard/admin/constants/nav.js
import {
  BarChart3,
  Users,
  Shield,
  GraduationCap,
  BookOpen,
  Megaphone,
  MessageSquare,
  Mail,
  Download,
  Bell,
  Building2,
  Settings,
} from "lucide-react";

/** Sidebar items */
export const NAV = [
  { type: "item", id: "overview", label: "Dashboard", icon: BarChart3 },

  { type: "section", label: "People" },
  { type: "item", id: "people-learners", label: "Learners", icon: Users },
  { type: "item", id: "people-instructors", label: "Instructors", icon: GraduationCap },
  { type: "item", id: "people-admins", label: "Admins", icon: Shield },

  { type: "section", label: "Courses" },
  { type: "item", id: "courses", label: "All Courses", icon: BookOpen },

  { type: "section", label: "Communication" },
  { type: "item", id: "announcements", label: "Announcements", icon: Megaphone },
  { type: "item", id: "sms", label: "SMS", icon: MessageSquare },
  { type: "item", id: "email", label: "Email", icon: Mail },

  { type: "section", label: "Reports & Analytics" },
  { type: "item", id: "reports", label: "Reports", icon: Download },
  { type: "item", id: "reminders", label: "Reminders", icon: Bell },

  { type: "section", label: "Hierarchy" },
  { type: "item", id: "hierarchy", label: "Conferences / Churches", icon: Building2 },

  { type: "section", label: "Settings" },
  { type: "item", id: "settings", label: "System Settings", icon: Settings },
];

export function navLabel(id) {
  const found = NAV.find((x) => x.type === "item" && x.id === id);
  return found?.label || "Admin";
}
